/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState, useContext, useEffect, useMemo } from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { isOperationAllowed, showToast } from "utils/helper";
import { UserContext } from "utils/reducers/user";
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Switch,
  ToggleGroup,
  ToggleGroupItem,
} from "@repo/ui";
import { CircleX } from "lucide-react";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { useGetCashCenters, useGetCustomers } from "utils/apis/lookups.api";
import {
  useGetWorkLoadRequests,
  useUpdateWorkLoadStatus,
} from "utils/apis/workload.api";
import AddFixedServices from "./add-fixed-services";
import { Permissions } from "utils/enums";

const daysOfWeek = [
  {
    id: "Monday",
    text: "Monday",
  },
  {
    id: "Tuesday",
    text: "Tuesday",
  },
  {
    id: "Wednesday",
    text: "Wednesday",
  },
  {
    id: "Thursday",
    text: "Thursday",
  },
  {
    id: "Friday",
    text: "Friday",
  },
  {
    id: "Saturday",
    text: "Saturday",
  },
  {
    id: "Sunday",
    text: "Sunday",
  },
];

const statusOptions = [
  {
    id: null,
    text: "All",
  },
  {
    id: true,
    text: "Active",
  },
  {
    id: false,
    text: "Paused",
  },
];

function WorkLoadAutomation() {
  const user = useContext(UserContext);
  const currentDate = new Date();
  const pageSize = 25;
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>({});
  const [workloadSummary, setWorkloadSummary] = useState([]);
  const [periodType, setPeriodType] = useState("DayOfWeek");

  const [showAddModel, setShowAddModel] = useState(false);

  const { data: cashCenters } = useGetCashCenters();
  const { data: customers } = useGetCustomers();

  const daysInMonth = useMemo(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    return new Date(year, month + 1, 0).getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dateOfMonth = useMemo(
    () =>
      Array.from({ length: daysInMonth }, (_, i) => ({
        id: (i + 1).toString(),
        text: (i + 1).toString(),
      })),
    [daysInMonth],
  );

  const {
    data: workLoadRequestsData,
    isError: workloadError,
    isPending: loaderPanel,
  } = useGetWorkLoadRequests({
    pageNumber: currentPage,
    pageRowCount: pageSize,
    searchCriteria: filters?.searchCriteria?.id,
    locationBarcode: filters?.locationBarcode?.id,
    isActive: filters?.status?.id,
    customerId: filters?.customer?.id,
    ...(periodType === "DayOfWeek"
      ? {
          dayOfWeek: filters?.dayOfWeek?.id,
        }
      : {
          dateOfMonth: filters?.dateOfMonth?.id,
        }),
    periodType,
    cashCenterId: filters?.cashCenter?.id || user.CashCenterId,
  });

  const { mutate: updateWorkLoadSchedulerStatus, isSuccess } =
    useUpdateWorkLoadStatus();

  useEffect(() => {
    if (workLoadRequestsData?.data) {
      setWorkloadSummary(workLoadRequestsData?.data);
    }
    if (workloadError) {
      setWorkloadSummary([]);
    }
  }, [workLoadRequestsData, workloadError]);

  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value },
    });
  };

  const toggleAddModel = () => {
    setShowAddModel(!showAddModel);
  };

  const onWorkloadAdded = () => {
    toggleAddModel();
  };

  function UpdateJobStatusButtonCell({ dataItem }: any) {
    const [isChecked, setIsChecked] = useState(dataItem.isActive);

    const onCbxStatusChanged = (isActive: boolean) => {
      setIsChecked(isActive);
      const { workloadId, sourceBarcode, onwardBarcode, requestNo } = dataItem;

      const updateDto = {
        workloadId,
        requestNo,
        sourceBarcode,
        onwardBarcode,
        isActive,
      };
      updateWorkLoadSchedulerStatus(updateDto);
    };

    useEffect(() => {
      if (isSuccess) {
        showToast("success", "Schedule status updated successfully!");
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);

    return (
      <td className="text-center mt-3">
        <Switch
          className="text-secondary"
          onCheckedChange={onCbxStatusChanged}
          checked={isChecked}
        />
      </td>
    );
  }

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>WorkLoad Automation</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex gap-3">
            <div className="flex gap-2 items-center">
              <ToggleGroup
                type="single"
                value={periodType}
                onValueChange={(val) => {
                  if (val) {
                    setPeriodType(val);
                  }
                }}
                className="flex border border-secondary"
              >
                <ToggleGroupItem
                  value="DayOfWeek"
                  className="px-6 py-2 text-sm font-medium rounded-l-md data-[state=on]:bg-[#b68a50] data-[state=on]:text-white data-[state=off]:bg-white data-[state=off]:text-[#b68a50]"
                >
                  Day Wise
                </ToggleGroupItem>
                <ToggleGroupItem
                  value="DateOfMonth"
                  className="px-6 py-2 text-sm font-medium rounded-r-md data-[state=on]:bg-[#b68a50] data-[state=on]:text-white data-[state=off]:bg-white data-[state=off]:text-[#b68a50]"
                >
                  Date Wise
                </ToggleGroupItem>
              </ToggleGroup>
            </div>

            <div className="flex-1 flex gap-3 justify-end">
              {isOperationAllowed(
                Permissions.OperationWindow,
                Permissions.Edit,
              ) ? (
                <Button
                  variant="secondary"
                  className="w-max"
                  onClick={toggleAddModel}
                >
                  Add/Update Workload
                </Button>
              ) : null}
            </div>
          </div>
          <div className="flex justify-between mt-3 gap-3">
            <div className="grid grid-cols-[repeat(4,_minmax(0,_240px))] gap-3">
              <Combobox
                value={JSON.stringify(filters?.cashCenter) || ""}
                placeholder="Select Cash Center"
                data={cashCenters?.map((item) => ({
                  value: JSON.stringify({
                    name: item.name,
                    id: item?.cashCenterId,
                  }),
                  label: item.name,
                }))}
                setValue={(val: string) => {
                  setFilters({
                    ...filters,
                    cashCenter: JSON.parse(val),
                  });
                }}
              />
              <Combobox
                value={JSON.stringify(filters?.customer) || ""}
                data={customers?.map((st: any) => ({
                  value: JSON.stringify({
                    name: st.name,
                    id: st.customerId,
                  }),
                  label: st.name,
                }))}
                placeholder="Select Customer"
                setValue={(val: string) => {
                  setFilters({
                    ...filters,
                    customer: JSON.parse(val),
                  });
                }}
              />

              {periodType === "DayOfWeek" ? (
                <Select
                  onValueChange={(val: string) => {
                    setFilters({
                      ...filters,
                      dayOfWeek: JSON.parse(val),
                    });
                  }}
                  value={JSON.stringify(filters?.dayOfWeek) || ""}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Day of Week" />
                  </SelectTrigger>
                  <SelectContent>
                    {daysOfWeek?.map((item) => (
                      <SelectItem
                        key={item.id}
                        value={JSON.stringify({
                          name: item.text,
                          id: item.id,
                        })}
                      >
                        {item.text}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <Select
                  onValueChange={(val: string) => {
                    setFilters({
                      ...filters,
                      dateOfMonth: JSON.parse(val),
                    });
                  }}
                  value={JSON.stringify(filters?.dateOfMonth) || ""}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Date of Month" />
                  </SelectTrigger>
                  <SelectContent>
                    {dateOfMonth?.map((item) => (
                      <SelectItem
                        key={item.id}
                        value={JSON.stringify({
                          name: item.text,
                          id: item.id,
                        })}
                      >
                        {item.text}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
              <Select
                onValueChange={(val: string) => {
                  setFilters({
                    ...filters,
                    status: JSON.parse(val),
                  });
                }}
                value={JSON.stringify(filters?.status) || ""}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select Status" />
                </SelectTrigger>
                <SelectContent>
                  {statusOptions?.map((item) => (
                    <SelectItem
                      key={item.text}
                      value={JSON.stringify({
                        name: item.text,
                        id: item.id,
                      })}
                    >
                      {item.text}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <Input
              className="max-w-[420px] w-full ml-auto"
              value={filters.searchCriteria?.id}
              onChange={onFilterSearch}
              placeholder="Search..."
            />
          </div>
          <div className="flex gap-2 flex-wrap mt-3 items-center">
            {Object.entries(filters).map(([key, val]: any, i) => (
              <Badge
                variant="secondary"
                className="gap-3 pr-1 cursor-pointer"
                key={i}
              >
                {val?.name}{" "}
                <CircleX
                  onClick={() => {
                    handleClearFilter(key);
                  }}
                />
              </Badge>
            ))}
          </div>
          <div className="border-b my-3 bg-accent" />

          {loaderPanel ? (
            <div className="text-center mt-5">
              <Loader size="large" type="converging-spinner" />
            </div>
          ) : (
            <Grid
              data={workloadSummary}
              onPageChange={onPageChange}
              pageable
              pageSize={pageSize}
              total={workLoadRequestsData?.totalRecords}
              skip={(currentPage - 1) * pageSize}
            >
              <Column field="cashCenter" title="Cash Center" />
              <Column field="customer" title="Customer" />
              <Column field="requestNo" title="Request No" width="120" />
              <Column
                field="sourceBarcode"
                title="Source"
                cell={({ dataItem }) => (
                  <td>
                    {dataItem?.sourceBarcode}-{dataItem?.sourceLocationName}
                  </td>
                )}
              />
              <Column
                field="onwardBarcode"
                title="Onward"
                cell={({ dataItem }) => (
                  <td>
                    {dataItem?.onwardBarcode}-{dataItem?.onwardLocationName}
                  </td>
                )}
              />
              <Column field="serviceType" title="Service Type" width="130" />
              {periodType === "DayOfWeek" ? (
                <Column field="dayOfWeek" title="Day of Week" width="130" />
              ) : (
                <Column field="dateOfMonth" title="Day of Month" width="130" />
              )}
              <Column field="jobType" title="Job Type" width="120" />
              <Column field="routeNo" title="Route No" width="130" />
              <Column
                width="70"
                title="Status"
                className="text-center"
                filterable={false}
                cell={UpdateJobStatusButtonCell}
              />
            </Grid>
          )}
          <Dialog open={showAddModel} onOpenChange={toggleAddModel}>
            <DialogContent className="max-w-[900px]">
              <DialogHeader className="pb-0">
                <DialogTitle>Add New Workload</DialogTitle>
              </DialogHeader>
              <DialogDescription className="overflow-auto max-h-[80vh]">
                <AddFixedServices onWorkloadAdded={onWorkloadAdded} />
              </DialogDescription>
            </DialogContent>
          </Dialog>
        </CardContent>
      </Card>
    </Layout>
  );
}

export default WorkLoadAutomation;
